import httpClient from '/src/utils/httpClient';

export function updateSplashScreenApiCall({
  id,
  type,
  welcomeTitle,
  welcomeText,
  welcomeButtonTitle,
  welcomeButtonActionType,
  welcomeButtonUrl,
  coverImagePreview,
  splashProductSelect,
  splashProductId,

  ctaActionType,
  ctaSite,
  ctaSiteText,
  ctaBackgroundColor,
  ctaTextColor,
  ctaItemId,
  ctaPageId,
  ctaBlockId,
}) {
  return httpClient.put(`api/splash-blocks/${blockId}`, {
    id,
    type: type,
    welcomeTitle: welcomeTitle,
    welcomeDescription: welcomeText,
    buttonTitle: welcomeButtonTitle,
    buttonAction: welcomeButtonActionType,
    buttonUrl: welcomeButtonUrl,
    mediaUrl: coverImagePreview ? coverImagePreview : '',
    mediaType: 1,

    productSelect: splashProductSelect,
    productId: splashProductId,

    ctaActionType,
    ctaUrl: ctaSite,
    ctaText: ctaSiteText,
    ctaBackgroundColor,
    ctaTextColor,
    ctaItemId,
    ctaPageId,
    ctaBlockId,
  });
}
